import { Modal, Button } from 'react-bootstrap'
import { MdWarningAmber } from 'react-icons/md'

export interface AsaasRefundConfirmProps {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  loading?: boolean
  cartCode?: string
}

export function AsaasRefundConfirm({
  show,
  onHide,
  onConfirm,
  loading = false,
  cartCode = '',
}: AsaasRefundConfirmProps) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      keyboard={false}
      style={{
        zIndex: 99999999
      }}
    >
      <Modal.Header closeButton>
        <div className="d-flex align-items-center gap-2">
          <MdWarningAmber size={24} color="#FFC107" />
          <Modal.Title>Confirmar Estorno</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">
          Você está prestes a cancelar o pedido <strong>wm{cartCode}</strong>.
        </p>
        <p className="mb-3">
          Como o pagamento foi realizado via <strong>Asaas</strong> e a opção de estorno automático está ativada, o valor será <strong>reembolsado</strong> ao cliente.
        </p>
        <div className="alert alert-info" role="alert">
          <small>
            O estorno pode levar alguns minutos para ser processado e refletir na conta do cliente.
          </small>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
          disabled={loading}
        >
          Somente Cancelar
        </Button>
        <Button
          variant="danger"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? 'Processando...' : 'Cancelar Pedido e Estornar'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
